import { render, staticRenderFns } from "./TaxaAssistencial.vue?vue&type=template&id=4bca5cd4&scoped=true&"
import script from "./TaxaAssistencial.vue?vue&type=script&lang=js&"
export * from "./TaxaAssistencial.vue?vue&type=script&lang=js&"
import style0 from "./TaxaAssistencial.vue?vue&type=style&index=0&id=4bca5cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca5cd4",
  null
  
)

export default component.exports